import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // GROUP EDITOR
  createGroupEditor: false,
  selectedRoutesIds: [],
  createGroupModal: false,

  // GET ROUTE GROUPS
  routeGroupsLoading: false,
  routeGroups: [],
  routeGroupsError: null,

  // GET FOR COPY ROUTE GROUPS
  routeGroupsForCopyLoading: false,
  routeGroupsForCopy: [],
  routeGroupsForCopyError: null,

  // CREATE ROUTE GROUP
  createGroupLoading: false,
  createGroupError: null,

  // UPDATE ROUTE GROUP
  updateGroupLoading: false,
  updateGroupError: null,

  // ADD ROUTE TO ROUTE GROUP
  addRouteToRouteGroupLoading: false,
  addRouteToRouteGroupError: null,

  // DELETE ROUTE FROM ROUTE GROUP
  deleteRouteFromRouteGroupLoading: false,
  deleteRouteFromRouteGroupError: null,

  // DELETE ROUTE GROUP
  deleteRouteGroupLoading: false,
  deleteRouteGroupError: null,

  // COPY ROUTE GROUP TO CLIPBOARD
  copyRouteGroupLoading: false,
  copyRouteGroupError: null,
};

export const routeGroupSlice = createSlice({
  name: "routeGroup",
  initialState,
  reducers: {
    toggleOpenGroupEditor: (state) => {
      state.createGroupEditor = true;
    },
    toggleCloseGroupEditor: (state) => {
      state.createGroupEditor = false;
    },
    toggleOpenCreateGroupModal: (state) => {
      state.createGroupModal = true;
    },
    toggleCloseCreateGroupModal: (state) => {
      state.createGroupModal = false;
      state.selectedRoutesIds = [];
    },
    insertRemoveRouteToRoutesIds: (state, action) => {
      if (state.selectedRoutesIds.includes(action.payload)) {
        state.selectedRoutesIds = state.selectedRoutesIds.filter(
          (id) => id !== action.payload
        );
      } else {
        state.selectedRoutesIds = [...state.selectedRoutesIds, action.payload];
      }
    },

    // GET ROUTE GROUPS
    getRouteGroupsFetch: (state) => {
      state.routeGroupsLoading = true;
      state.routeGroups = [];
      state.routeGroupsError = null;
    },
    getRouteGroupsSuccess: (state, action) => {
      state.routeGroupsLoading = false;
      state.routeGroups = action.payload;
      state.routeGroupsError = null;
    },
    getRouteGroupsError: (state, action) => {
      state.routeGroupsLoading = false;
      state.routeGroups = [];
      state.routeGroupsError = action.payload;
    },

    // GET FOR COPY ROUTE GROUPS
    getForCopyRouteGroupsFetch: (state) => {
      state.routeGroupsForCopyLoading = true;
      state.routeGroupsForCopy = [];
      state.routeGroupsForCopyError = null;
    },
    getForCopyRouteGroupsSuccess: (state, action) => {
      state.routeGroupsForCopyLoading = false;
      state.routeGroupsForCopy = action.payload;
      state.routeGroupsForCopyError = null;
    },
    getForCopyRouteGroupsError: (state, action) => {
      state.routeGroupsForCopyLoading = false;
      state.routeGroupsForCopy = [];
      state.routeGroupsForCopyError = action.payload;
    },

    // CREATE ROUTE GROUP
    createRouteGroupPost: (state) => {
      state.createGroupLoading = true;
      state.createGroupError = null;
    },
    createRouteGroupSuccess: (state) => {
      state.createGroupLoading = false;
      state.createGroupError = null;
    },
    createRouteGroupError: (state, action) => {
      state.createGroupLoading = false;
      state.createGroupError = action.payload;
    },

    // UPDATE ROUTE GROUP
    updateRouteGroupPut: (state) => {
      state.updateGroupLoading = true;
      state.updateGroupError = null;
    },
    updateRouteGroupSuccess: (state) => {
      state.updateGroupLoading = false;
      state.updateGroupError = null;
    },
    updateRouteGroupError: (state, action) => {
      state.updateGroupLoading = false;
      state.updateGroupError = action.payload;
    },

    // ADD ROUTE TO ROUTE GROUP
    addRouteToRouteGroupPut: (state) => {
      state.addRouteToRouteGroupLoading = true;
      state.addRouteToRouteGroupError = null;
    },
    addRouteToRouteGroupSuccess: (state) => {
      state.addRouteToRouteGroupLoading = false;
      state.addRouteToRouteGroupError = null;
    },
    addRouteToRouteGroupError: (state, action) => {
      state.addRouteToRouteGroupLoading = false;
      state.addRouteToRouteGroupError = action.payload;
    },

    // DELETE ROUTE FROM ROUTE GROUP
    deleteRouteFromRouteGroupPut: (state) => {
      state.deleteRouteFromRouteGroupLoading = true;
      state.deleteRouteFromRouteGroupError = null;
    },
    deleteRouteFromRouteGroupSuccess: (state) => {
      state.deleteRouteFromRouteGroupLoading = false;
      state.deleteRouteFromRouteGroupError = null;
    },
    deleteRouteFromRouteGroupError: (state, action) => {
      state.deleteRouteFromRouteGroupLoading = false;
      state.deleteRouteFromRouteGroupError = action.payload;
    },

    // DELETE ROUTE GROUP
    deleteRouteGroupDelete: (state) => {
      state.deleteRouteGroupLoading = true;
      state.deleteRouteGroupError = null;
    },
    deleteRouteGroupSuccess: (state) => {
      state.deleteRouteGroupLoading = false;
      state.deleteRouteGroupError = null;
    },
    deleteRouteGroupError: (state, action) => {
      state.deleteRouteGroupLoading = false;
      state.deleteRouteGroupError = action.payload;
    },

    // COPY ROUTE GROUP TO CLIPBOARD
    copyRouteGroupToClipboard: (state) => {
      state.copyRouteGroupLoading = true;
      state.copyRouteGroupError = null;
    },
    copyRouteGroupToClipboardSuccess: (state) => {
      state.copyRouteGroupLoading = false;
      state.copyRouteGroupError = null;
    },
    copyRouteGroupToClipboardError: (state, action) => {
      state.copyRouteGroupLoading = false;
      state.copyRouteGroupError = action.payload;
    },

  },
});

export const routeGroupActions = routeGroupSlice.actions;
export const routeGroupReducers = routeGroupSlice.reducer;
